export const MAC_DEVICES = ["Mac68K", "MacPPC", "MacIntel"];

export const IPHONE_DEVICES = [
  "iPhone",
  "iPod",
  "iPad",
  "iPhone Simulator",
  "iPod Simulator",
  "iPad Simulator",
  "Macintosh",
  "MacIntel",
  "MacPPC",
  "Mac68K",
  "Pike v7.6 release 92",
  "Pike v7.8 release 517",
];

export const WINDOWS_DEVICES = [
  "SunOS",
  "Win16",
  "Win32",
  "WinCE",
  "Opera",
  "Linux",
  "Linux aarch64",
  "Linux armv5tejl",
  "Linux armv6l",
  "Linux armv7l",
  "Linux armv8l",
  "Linux i686",
  "Linux i686 on x86_64",
  "Linux i686 X11",
  "Linux MSM8960_v3.2.1.1_N_R069_Rev:18",
  "Linux ppc64",
  "Linux x86_64",
  "Linux x86_64 X11",
];
